export const NUMBER_FORMAT_STORAGE_KEY = "broker_wallet_number_format";

export const NUMBER_FORMAT_OPTIONS = [
  { value: "space", label: "Spaces" },
  { value: "comma", label: "Commas" },
];

export function getStoredNumberFormat() {
  try {
    const storedFormat = localStorage.getItem(NUMBER_FORMAT_STORAGE_KEY);
    return NUMBER_FORMAT_OPTIONS.some(({ value }) => value === storedFormat)
      ? storedFormat
      : "space";
  } catch {
    return "space";
  }
}

function groupInteger(integerPart, numberFormat) {
  const thousandsSeparator = numberFormat === "comma" ? "," : " ";
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
}

export function formatMoney(value, numberFormat = "space") {
  const number = Number(value);
  if (!Number.isFinite(number)) return "0.00";

  const [integerPart, decimalPart] = Math.abs(number).toFixed(2).split(".");
  return `${number < 0 ? "-" : ""}${groupInteger(
    integerPart,
    numberFormat
  )}.${decimalPart}`;
}

export function formatTransactionAmount(value, numberFormat = "space") {
  const rawValue = String(value ?? "").trim();
  if (!rawValue || !/^[+-]?\d+(?:\.\d+)?$/.test(rawValue)) {
    return rawValue || "-";
  }

  const sign = rawValue.startsWith("-") ? "-" : "";
  const unsignedValue = rawValue.replace(/^[+-]/, "");
  const [integerPart, decimalPart] = unsignedValue.split(".");
  const formattedInteger = groupInteger(integerPart, numberFormat);

  return `${sign}${formattedInteger}${
    decimalPart === undefined ? "" : `.${decimalPart}`
  }`;
}
